import React from 'react'

import { SideHeader, Team } from '../../components'
import CustomTitle from '../../utils/CustomTitle'

import './TeamPage.css'

function TeamPage() {
  return (
    <div className='teamPage'>
      <CustomTitle title="MEC CS | Team"/>
      <div className='page__section'>
        <SideHeader title="Team"/>
        <Team />
      </div>
    </div>
  )
}

export default TeamPage